/**
 * 弹层打开时锁定底层页面滚动（支持嵌套弹层引用计数）
 */

let lockCount = 0;
let savedScrollY = 0;
let savedBodyStyle: Partial<CSSStyleDeclaration> | null = null;
let touchMoveHandler: ((e: TouchEvent) => void) | null = null;

const isBrowser = () => typeof document !== 'undefined' && typeof window !== 'undefined';

const preventTouchMove = (e: TouchEvent) => {
  // 允许弹层内部滚动区域继续滑动
  const target = e.target as HTMLElement | null;
  if (!target) {
    e.preventDefault();
    return;
  }
  let el: HTMLElement | null = target;
  while (el && el !== document.body) {
    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    const canScroll =
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight;
    if (canScroll) return;
    if (el.classList?.contains('lanhu-sheet') || el.classList?.contains('uni-scroll-view')) {
      // scroll-view / sheet 内部交给组件自己处理
      return;
    }
    el = el.parentElement;
  }
  e.preventDefault();
};

export const lockPageScroll = () => {
  lockCount += 1;
  if (lockCount > 1 || !isBrowser()) return;

  const body = document.body;
  const html = document.documentElement;
  savedScrollY = window.scrollY || html.scrollTop || 0;
  savedBodyStyle = {
    overflow: body.style.overflow,
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
  };

  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${savedScrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  html.style.overflow = 'hidden';

  touchMoveHandler = preventTouchMove;
  document.addEventListener('touchmove', touchMoveHandler, { passive: false });
};

export const unlockPageScroll = () => {
  if (lockCount <= 0) return;
  lockCount -= 1;
  if (lockCount > 0 || !isBrowser()) return;

  if (touchMoveHandler) {
    document.removeEventListener('touchmove', touchMoveHandler);
    touchMoveHandler = null;
  }

  const body = document.body;
  const html = document.documentElement;
  const prev = savedBodyStyle;
  body.style.overflow = prev?.overflow ?? '';
  body.style.position = prev?.position ?? '';
  body.style.top = prev?.top ?? '';
  body.style.left = prev?.left ?? '';
  body.style.right = prev?.right ?? '';
  body.style.width = prev?.width ?? '';
  html.style.overflow = '';
  savedBodyStyle = null;

  window.scrollTo(0, savedScrollY);
  savedScrollY = 0;
};

/** 强制清空（页面卸载兜底） */
export const resetPageScrollLock = () => {
  if (lockCount <= 0) return;
  lockCount = 1;
  unlockPageScroll();
};
